export interface PhoneCountry {
    code: string;
    prefix: string;
    name: string;
    flag: string;
}

function flagUrl(code: string): string {
    return `/assets/flags/${code.toLowerCase()}-svg.svg`;
}

export const PHONE_COUNTRIES: PhoneCountry[] = [
    { code: 'FR', prefix: '+33', name: 'France', flag: flagUrl('FR') },
    // Limitrophes
    { code: 'GB', prefix: '+44', name: 'Royaume-Uni', flag: flagUrl('GB') },
    { code: 'DE', prefix: '+49', name: 'Allemagne', flag: flagUrl('DE') },
    { code: 'ES', prefix: '+34', name: 'Espagne', flag: flagUrl('ES') },
    { code: 'IT', prefix: '+39', name: 'Italie', flag: flagUrl('IT') },
    { code: 'BE', prefix: '+32', name: 'Belgique', flag: flagUrl('BE') },
    { code: 'CH', prefix: '+41', name: 'Suisse', flag: flagUrl('CH') },
    { code: 'LU', prefix: '+352', name: 'Luxembourg', flag: flagUrl('LU') },
    { code: 'IE', prefix: '+353', name: 'Irlande', flag: flagUrl('IE') },
    { code: 'WLS', prefix: '+46', name: 'Pays de Galles', flag: flagUrl('WLS') },
    // Reste Europe
    { code: 'AT', prefix: '+43', name: 'Autriche', flag: flagUrl('AT') },
    { code: 'HR', prefix: '+385', name: 'Croatie', flag: flagUrl('HR') },
    { code: 'DK', prefix: '+45', name: 'Danemark', flag: flagUrl('DK') },
    { code: 'GR', prefix: '+30', name: 'Grèce', flag: flagUrl('GR') },
    { code: 'FI', prefix: '+358', name: 'Finlande', flag: flagUrl('FI') },
    { code: 'HU', prefix: '+36', name: 'Hongrie', flag: flagUrl('HU') },
    { code: 'NO', prefix: '+47', name: 'Norvège', flag: flagUrl('NO') },
    { code: 'NL', prefix: '+31', name: 'Pays-Bas', flag: flagUrl('NL') },
    { code: 'PL', prefix: '+48', name: 'Pologne', flag: flagUrl('PL') },
    { code: 'PT', prefix: '+351', name: 'Portugal', flag: flagUrl('PT') },
    { code: 'RO', prefix: '+40', name: 'Roumanie', flag: flagUrl('RO') },
    { code: 'SK', prefix: '+421', name: 'Slovaquie', flag: flagUrl('SK') },
    { code: 'SE', prefix: '+46', name: 'Suède', flag: flagUrl('SE') },
    { code: 'CZ', prefix: '+420', name: 'Tchéquie', flag: flagUrl('CZ') },
];
